import * as React from 'react';

import cn from 'classnames';

import { noop } from '@utils';

import { IRadioButtonProps } from './types';

import * as s from './RadioButton.scss';

export const RadioButton = ({
	id,
	label,
	isDisabled,
	value,
	name,
	isDefaultChecked,
	onRadioButtonClick = noop,
	isChecked,
	classNameContainer,
	classNameContainerLabel,
}: IRadioButtonProps) => {
	const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.currentTarget.checked) {
			onRadioButtonClick(event.currentTarget.value);
		}
	};

	return (
		<label htmlFor={id} className={cn(s.container, { [s.containerDisabled]: isDisabled }, classNameContainer)}>
			<input
				type="radio"
				id={id}
				className={s.radio}
				value={value}
				name={name}
				disabled={isDisabled}
				onChange={onChange}
				defaultChecked={isDefaultChecked}
				checked={isChecked}
			/>
			{label && <span className={cn(s.labelText, classNameContainerLabel, { [s.labelTextDisabled]: isDisabled })}>{label}</span>}
		</label>
	);
};
